import React, { useState } from 'react';
import FooterPageLayout from '../../components/layouts/FooterPageLayout';
import { TrendingUp, Users, Target, CheckCircle, Calendar, Award, Rocket } from 'lucide-react';

const Invest = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    investmentInterest: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Email will be sent to Pebble team
    console.log('Investor inquiry submitted:', formData);
    alert('Thank you for your interest! We will be in touch shortly.');
  };

  return (
    <FooterPageLayout>
      <div className="min-h-screen bg-gradient-to-b from-grey-50 to-white">
        {/* Hero Section */}
        <div className="bg-white py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="flex justify-center mb-2">
                <Rocket className="w-8 h-8 text-[#B22A2B]" />
              </div>
              <div className="inline-block bg-red-50 border border-[#B22A2B]/20 rounded-full px-3 py-1 mb-2">
                <span className="text-xs font-semibold text-[#B22A2B]">PRESEED FUNDRAISING ROUND</span>
              </div>
              <h1 className="text-3xl font-bold mb-2 text-[#B22A2B]">Invest in Pebble</h1>
              <p className="text-base max-w-2xl mx-auto text-grey-700">
                Built for festival organizers by a festival organizer. We support ALL marketplace driven events and are building the future of how event organizers and vendors connect.
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Launch Countdown */}
          <div className="bg-gradient-to-r from-[#B22A2B] to-[#8a2122] rounded-xl shadow-lg p-8 mb-12 text-white text-center">
            <div className="flex items-center justify-center mb-4">
              <Calendar className="w-8 h-8 mr-3" />
              <h2 className="text-3xl font-bold">Official Launch Date</h2>
            </div>
            <p className="text-5xl font-bold mb-2">March 15, 2026</p>
            <p className="text-lg opacity-90">Get in early on the ground floor</p>
          </div>

          {/* Who We're Looking For */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-grey-900 mb-6 text-center">We're Seeking Investment From</h2>
            <div className="bg-gradient-to-br from-red-50 to-white rounded-xl shadow-sm p-8 border-2 border-[#B22A2B]/20">
              <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-[#B22A2B] rounded-full mr-3"></div>
                  <span className="text-grey-700 font-medium">Angel Investors</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-[#B22A2B] rounded-full mr-3"></div>
                  <span className="text-grey-700 font-medium">Family Offices</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-[#B22A2B] rounded-full mr-3"></div>
                  <span className="text-grey-700 font-medium">Venture Capital</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-[#B22A2B] rounded-full mr-3"></div>
                  <span className="text-grey-700 font-medium">Grants</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-[#B22A2B] rounded-full mr-3"></div>
                  <span className="text-grey-700 font-medium">Corporate Investment</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-[#B22A2B] rounded-full mr-3"></div>
                  <span className="text-grey-700 font-medium">Philanthropic</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-[#B22A2B] rounded-full mr-3"></div>
                  <span className="text-grey-700 font-medium">Private Investors</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-[#B22A2B] rounded-full mr-3"></div>
                  <span className="text-grey-700 font-medium">Athletes & Artists</span>
                </div>
              </div>
              <p className="text-grey-600 text-center mt-6 text-sm">
                Especially those with connections or expertise in the events space
              </p>
            </div>
          </div>

          {/* Traction Metrics */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-grey-900 mb-8 text-center">Proven Traction</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 border-t-4 border-[#B22A2B]">
                <div className="text-center">
                  <Users className="w-10 h-10 text-[#B22A2B] mx-auto mb-3" />
                  <p className="text-4xl font-bold text-grey-900 mb-2">300+</p>
                  <p className="text-grey-600 font-medium">User Interviews</p>
                  <p className="text-sm text-grey-500 mt-2">Deep market validation</p>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 border-t-4 border-[#B22A2B]">
                <div className="text-center">
                  <CheckCircle className="w-10 h-10 text-[#B22A2B] mx-auto mb-3" />
                  <p className="text-4xl font-bold text-grey-900 mb-2">3</p>
                  <p className="text-grey-600 font-medium">Signed LOIs</p>
                  <p className="text-sm text-grey-500 mt-2">Letters of Intent secured</p>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 border-t-4 border-[#B22A2B]">
                <div className="text-center">
                  <Target className="w-10 h-10 text-[#B22A2B] mx-auto mb-3" />
                  <p className="text-4xl font-bold text-grey-900 mb-2">40+</p>
                  <p className="text-grey-600 font-medium">Waitlist Users</p>
                  <p className="text-sm text-grey-500 mt-2">Growing daily</p>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 border-t-4 border-[#B22A2B]">
                <div className="text-center">
                  <Award className="w-10 h-10 text-[#B22A2B] mx-auto mb-3" />
                  <p className="text-4xl font-bold text-grey-900 mb-2">10K+</p>
                  <p className="text-grey-600 font-medium">Pilot Attendees</p>
                  <p className="text-sm text-grey-500 mt-2">2 major festivals hosted</p>
                </div>
              </div>
            </div>
          </div>

          {/* Why Invest */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
            <h2 className="text-3xl font-bold text-grey-900 mb-6 text-center">Why Invest in Pebble?</h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="border-2 border-grey-200 rounded-lg p-6 hover:border-[#B22A2B] transition-colors">
                <div className="bg-red-100 p-3 rounded-lg w-fit mb-4">
                  <TrendingUp className="w-6 h-6 text-[#B22A2B]" />
                </div>
                <h3 className="text-xl font-semibold text-grey-900 mb-3">Massive Market Opportunity</h3>
                <p className="text-grey-600">
                  The event and marketplace industry is a multi-billion dollar market experiencing rapid digital transformation. Pebble is positioned to capture significant market share.
                </p>
              </div>

              <div className="border-2 border-grey-200 rounded-lg p-6 hover:border-[#B22A2B] transition-colors">
                <div className="bg-red-100 p-3 rounded-lg w-fit mb-4">
                  <Users className="w-6 h-6 text-[#B22A2B]" />
                </div>
                <h3 className="text-xl font-semibold text-grey-900 mb-3">Validated Product-Market Fit</h3>
                <p className="text-grey-600">
                  Over 300 user interviews, signed LOIs from major event organizers, and successful pilots at festivals with 10,000+ attendees prove strong demand.
                </p>
              </div>

              <div className="border-2 border-grey-200 rounded-lg p-6 hover:border-[#B22A2B] transition-colors">
                <div className="bg-red-100 p-3 rounded-lg w-fit mb-4">
                  <Rocket className="w-6 h-6 text-[#B22A2B]" />
                </div>
                <h3 className="text-xl font-semibold text-grey-900 mb-3">Experienced Team & Clear Vision</h3>
                <p className="text-grey-600">
                  Our team combines deep industry expertise with technical innovation. We have a clear roadmap and proven execution capability.
                </p>
              </div>
            </div>
          </div>

          {/* Investment Opportunities */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-grey-900 mb-8 text-center">Investment Opportunities</h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-grey-50 to-white border-2 border-grey-200 rounded-xl p-8 hover:border-[#B22A2B] transition-all hover:shadow-lg">
                <h3 className="text-2xl font-bold text-grey-900 mb-4">Preseed Round</h3>
                <p className="text-grey-700 mb-6 text-lg">
                  Join our preseed fundraising round and become an early stakeholder in Pebble's future. Get in before our official March 2026 launch.
                </p>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-grey-700">Early investor pricing</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-grey-700">Advisory board opportunities</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-grey-700">Regular updates and transparency</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-grey-700">Network access to partners and events</span>
                  </li>
                </ul>
                <p className="text-sm text-grey-600">Minimum investment: $25,000</p>
              </div>

              <div className="bg-gradient-to-br from-grey-50 to-white border-2 border-grey-200 rounded-xl p-8 hover:border-[#B22A2B] transition-all hover:shadow-lg">
                <h3 className="text-2xl font-bold text-grey-900 mb-4">Strategic Partnership</h3>
                <p className="text-grey-700 mb-6 text-lg">
                  Explore strategic investment opportunities that combine capital with industry expertise, network access, or complementary services.
                </p>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-grey-700">Co-development opportunities</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-grey-700">Revenue sharing models</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-grey-700">Joint marketing initiatives</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-grey-700">Custom partnership structures</span>
                  </li>
                </ul>
                <p className="text-sm text-grey-600">Flexible investment terms</p>
              </div>
            </div>
          </div>

          {/* Contact Investor Relations */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-grey-900 mb-6 text-center">Request Investor Information</h2>
            <p className="text-center text-grey-600 mb-8 max-w-2xl mx-auto">
              Interested in joining our preseed round? Fill out the form below to receive our investor deck, financial projections, and detailed information about this opportunity.
            </p>
            <form onSubmit={handleSubmit} className="max-w-2xl mx-auto space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-grey-700 mb-2">
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-2 border border-grey-300 rounded-lg focus:ring-2 focus:ring-[#B22A2B] focus:border-transparent"
                    placeholder="John Doe"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-grey-700 mb-2">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-2 border border-grey-300 rounded-lg focus:ring-2 focus:ring-[#B22A2B] focus:border-transparent"
                    placeholder="john@example.com"
                  />
                </div>
              </div>
              
              <div>
                <label htmlFor="company" className="block text-sm font-medium text-grey-700 mb-2">
                  Company / Fund Name
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-grey-300 rounded-lg focus:ring-2 focus:ring-[#B22A2B] focus:border-transparent"
                  placeholder="Acme Ventures"
                />
              </div>
              
              <div>
                <label htmlFor="investmentInterest" className="block text-sm font-medium text-grey-700 mb-2">
                  Investment Interest <span className="text-red-500">*</span>
                </label>
                <select
                  id="investmentInterest"
                  name="investmentInterest"
                  value={formData.investmentInterest}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border border-grey-300 rounded-lg focus:ring-2 focus:ring-[#B22A2B] focus:border-transparent"
                >
                  <option value="">Select range</option>
                  <option value="25k-100k">$25,000 - $100,000</option>
                  <option value="100k-500k">$100,000 - $500,000</option>
                  <option value="500k-1m">$500,000 - $1,000,000</option>
                  <option value="1m+">$1,000,000+</option>
                  <option value="strategic">Strategic Partnership</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-grey-700 mb-2">
                  Message (Optional)
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  className="w-full px-4 py-2 border border-grey-300 rounded-lg focus:ring-2 focus:ring-[#B22A2B] focus:border-transparent"
                  placeholder="Tell us about your investment thesis or any questions you have..."
                />
              </div>

              <button
                type="submit"
                className="w-full bg-[#B22A2B] text-white px-6 py-4 rounded-lg text-lg font-semibold hover:bg-[#8a2122] transition-colors shadow-lg hover:shadow-xl"
              >
                Request Investor Packet
              </button>

              <p className="text-xs text-grey-500 text-center">
                Our team will review your inquiry and respond within 24-48 hours
              </p>
            </form>
          </div>
        </div>
      </div>
    </FooterPageLayout>
  );
};

export default Invest;
